import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'preact/compat';
import useTimeout from 'beautiful-react-hooks/useTimeout';
import { useAppDispatch } from '@basket/store/hooks';
import { removeNotice } from '@basket/store/actions/notices';
export default function Notice(props) {
    const { id, message, level } = props;
    const dispatch = useAppDispatch();
    const handleClose = useCallback(() => {
        dispatch(removeNotice(id));
    }, [dispatch, id]);
    useTimeout(() => {
        dispatch(removeNotice(id));
    }, 10000);
    const className = clsx([
        'notice',
        level ? `notice--${level}` : null,
    ]);
    return (_jsxs("div", { id: id, className: className, children: [_jsx("span", { className: "notice__message", children: message }), _jsx("div", { className: "notice__actions", children: _jsx("button", { type: "button", className: "icon-button", onClick: handleClose, "aria-label": "Remove notice", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }) })] }));
}
